export interface MessageThread {
    messages: any;
    contextPurpose: string;
    subject: string;
    clientName: string;
    clientCompany: string;
    sentTo: string;
    message: string;
    id: string;
    createdBy: string;
    createdAt: string;
    readFlag: boolean;
    archiveFlag: boolean;
    pinnedFlag: boolean;
    clientId:any;
    latestMessage?: string;
    latestMessageTime?: string;
    userDisplayFirstName?: string;
    userDisplayLastName?: string;
}

export interface Message { 
    id: string;
    sentTo: string;
    message: string;
    createdBy: string;
    createdAt: string;
    readFlag: boolean;
    attachmentName: string;
    attachmentPath: string;
    messageType: string;
    firstName?: string;
    lastName?: string;
    userDisplayFirstName?:string;
    userDisplayLastName?:string;
}
    
export interface postMessageThreadData {
    clientName: string;
    clientCompany: string;
    createdBy: string;
    clientId: string;
    sentTo: string;
    subject: string;
    message: {
      message: string;
      messageType: string;
    };
  }
  
export interface postMessageData {
  id: string;
  message: {
    message: string;
    messageType: string;
    createdBy: string;
    sentTo: string;
  };
}

export interface UserModel {
  userId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  status: string;
  orgId: string|undefined|null;
  name?: string;
  clientId?: string;
  firstLogin: boolean;
  clientCompany?: string;
  clientFirstName?: string;
  clientLastName?: string;
}

export class MessageThreadImpl implements MessageThread{
    messages: any;
    contextPurpose!: string;
    subject!: string;
    clientName!: string;
    clientCompany!: string;
    sentTo!: string;
    message!: string;
    id!: string;
    createdBy!: string;
    createdAt!: string;
    readFlag!: boolean;
    archiveFlag!: boolean;
    pinnedFlag!: boolean;
    clientId: any;
    latestMessage?: string | undefined;
    latestMessageTime?: string | undefined;
    userDisplayFirstName?: string | undefined;
    userDisplayLastName?: string | undefined;
   

}
